var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMobilePage)?_c('H5',{attrs:{"backPrev":_vm.backPrev,"showBackTip":_vm.showBackTip},on:{"exam-title-change":_vm.setExamTitle}}):_c('PC',{attrs:{"backPrev":_vm.backPrev,"showBackTip":_vm.showBackTip}})}
var staticRenderFns = []

export { render, staticRenderFns }